// The product is AY TMS. The old `km-tms.` state is not carried across (Alan, 2026-07-31).
const STORAGE_PREFIX = 'ay-tms.dashboard.preferences.v1:';
const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

function validDate(value) {
  if (typeof value !== 'string' || !DATE_PATTERN.test(value)) return '';
  const parsed = Date.parse(`${value}T00:00:00.000Z`);
  return Number.isFinite(parsed) ? value : '';
}

function storedRecord(storage, key) {
  try {
    const value = JSON.parse(storage.getItem(key) || '{}');
    return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
  } catch {
    return {};
  }
}

export function createDashboardPreferenceStore({ storage, userKey }) {
  if (!storage || typeof storage.getItem !== 'function' || typeof storage.setItem !== 'function'
    || typeof userKey !== 'string' || !userKey.trim()) {
    throw new TypeError('Dashboard preference store is invalid.');
  }
  const key = `${STORAGE_PREFIX}${userKey.trim()}`;

  return {
    load({ authorizedDateFields = [] } = {}) {
      const value = storedRecord(storage, key);
      const allowed = Array.isArray(authorizedDateFields)
        ? authorizedDateFields.filter((item) => typeof item === 'string' && item) : [];
      const dateField = allowed.includes(value.dateField) ? value.dateField : allowed[0] ?? '';
      let from = validDate(value.from);
      let to = validDate(value.to);
      if (!from || !to || from > to) {
        from = '';
        to = '';
      }
      return {
        motion: typeof value.motion === 'boolean' ? value.motion : true,
        dateField,
        from,
        to,
        // Whether the table opens split into 空柜 and 其他 (Alan, 2026-09-21). A
        // view preference like the date range: it is how this person reads the
        // fleet, so it should still be that way tomorrow.
        browseSplit: value.browseSplit === true,
      };
    },
    save(patch) {
      const current = storedRecord(storage, key);
      const next = patch && typeof patch === 'object' ? { ...current, ...patch } : current;
      storage.setItem(key, JSON.stringify(next));
      return next;
    },
  };
}
